export default __webpack_public_path__ + "static/media/search.fe73f971.svg";